/**
 * Parse an admin-supplied video URL into something the player can render.
 * Supports YouTube, Vimeo (rendered as autoplay iframes) and direct
 * video files (.mp4 / .webm / .ogg, rendered with a native <video> element).
 *
 * Returns null when the url is empty/unusable.
 *   { type: "embed", src }  -> render in an <iframe>
 *   { type: "file",  src }  -> render in a <video> element
 */
export function parseVideo(url) {
  if (!url || typeof url !== "string") return null;
  const u = url.trim();
  if (!u) return null;

  // YouTube: watch?v=, youtu.be/, embed/, shorts/
  let m = u.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/
  );
  if (m) {
    return {
      type: "embed",
      src: `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0&modestbranding=1`,
    };
  }

  // Vimeo: vimeo.com/123456789 or player.vimeo.com/video/123456789
  m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (m) {
    return {
      type: "embed",
      src: `https://player.vimeo.com/video/${m[1]}?autoplay=1&title=0&byline=0&portrait=0`,
    };
  }

  // Otherwise treat as a direct video file URL — but only accept safe
  // http(s) (or protocol-relative) schemes so stray/dangerous values
  // (e.g. "javascript:…") never reach a <video src>.
  if (/^(https?:)?\/\//i.test(u)) return { type: "file", src: u };
  return null;
}
